import {page_json, progress} from '../progress/feature.progress.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import * as debug_actions from "../debug/actions_debug.svelte.js";
import DebugUtil from "../../utils/DebugUtil.js";
import * as money_util from "../../utils/MoneyUtil.js";
import * as progress_select from "../progress/progress.scenarios.select.svelte.js";
import DateTimeUtil from "../../utils/DateTimeUtil.js";
import {packagedeals} from "./feature.packagedeals.svelte.js";
import * as booking_update from "../booking/booking.scenarios.update.svelte.js";

// zie actions_progress.apiCallRequestPackageDeals
// export function apiCallPackageDealsSuccess(html)
// {
//   debug_actions.debugAddLogFlow('packagedeals', 'apiCallPackageDealsSuccess', {html});
//   // Zet progress.bIsFetchingPackageDeals op false
//   progress.bIsFetchingPackageDeals = false;
// }

export function importFromPageConfigAjaxCall()
{
  // De aanbevolen arrangementen
  if ( typeof page_json.data.jsonHmkRecDeals !== 'undefined' )
  {
    packagedeals.aRecommendedPackageDealIDs = page_json.data.jsonHmkRecDeals;
  }

  // De arrangementcatalogus
  let aStateItems = packagedeals.lItems;

  if ( typeof page_json.data.jsonHmkCataloguePackageDeals === 'undefined' )
  {
    DebugUtil.log('jsonHmkCataloguePackageDeals undefined', DebugUtil.DEBUG_CAT_ERRORS_GENERAL);
  }
  else
  {
    const oInput = page_json.data.jsonHmkCataloguePackageDeals;
    if ( oInput !== false )
    {
      let oPackageDeal, iPackageDealID;
      for ( const oValFromJSON of oInput )
      {
        if ( typeof oValFromJSON.ID !== 'undefined' )
        {
          oPackageDeal = {};
          iPackageDealID = parseInt(oValFromJSON.ID);

          // ID: "1370"
          // Title: "Entree + live cooking buffet"
          // DefaultTime: "09:00"
          // MaxDays: "1"
          // Products: [
          //     AdditionalCosts: "0.00"
          //     ID: "11491"
          //     IsChoice: "0" // NB 0 is niet optioneel maar alles daarboven is het nummer van de groepering.. het is dus geen boolean
          //     IsTogether: "1"
          //     Summary: null
          //     Type: "0"
          //     ExternalID: "47"
          // ]

          const idx = aStateItems.findIndex((oAlreadyAddedPackageDeal) => oAlreadyAddedPackageDeal.iID === iPackageDealID);

          // alleen product toevoegen als we die nog niet hebben (ook ivm onbedoeld meerdere keren parsen)
          if ( idx === -1 )
          {
            oPackageDeal.iID = parseInt(oValFromJSON.ID);
            if ( typeof oValFromJSON.Pr !== 'undefined' ) oPackageDeal.iPrice = money_util.stringToCents(oValFromJSON.Pr);
            if ( typeof oValFromJSON.Ti !== 'undefined' ) oPackageDeal.sTitle = oValFromJSON.Ti;
            // if ( typeof oValFromJSON.MaxDays !== 'undefined' ) oPackageDeal.iMaxDays = parseInt(oValFromJSON.MaxDays);

            oPackageDeal.bContainsTreatments = false;
            if ( typeof oValFromJSON.ConTr !== 'undefined' && oValFromJSON.ConTr === "1" || oValFromJSON.ConTr === 1 ) oPackageDeal.bContainsTreatments = true;

            oPackageDeal.bContainsDinner = false;
            if ( typeof oValFromJSON.ConDi !== 'undefined' && oValFromJSON.ConDi === "1" || oValFromJSON.ConDi === 1 ) oPackageDeal.bContainsDinner = true;

            const aProductsInPackageDeal = [];
            if ( typeof oValFromJSON.Products !== 'undefined' )
            {

              for ( const oProductValFromJson of oValFromJSON.Products )
              {
                if ( typeof oProductValFromJson.XID !== 'undefined' )
                {
                  const oProductInPackageDeal = {};
                  oProductInPackageDeal.iID = parseInt(oProductValFromJson.XID);
                  if ( typeof oProductValFromJson.AddC !== 'undefined' ) oProductInPackageDeal.iAdditionalCosts = money_util.stringToCents(oProductValFromJson.AddC);
                  if ( typeof oProductValFromJson.Type !== 'undefined' ) oProductInPackageDeal.iType = parseInt(oProductValFromJson.Type);

                  if ( typeof oProductValFromJson.Ch !== 'undefined' )
                  {
                    oProductInPackageDeal.iChoiceID = false;

                    if ( oProductValFromJson.Ch !== "0" ) oProductInPackageDeal.iChoiceID = parseInt(oProductValFromJson.Ch); // > 0 is ID nummer van de groep
                  }

                  // if ( typeof oProductValFromJson.IsTogether !== 'undefined' )
                  // {
                  //     oProductInPackageDeal.bIsTogether = false;
                  //     if ( oProductValFromJson.IsTogether === "1" ) oProductInPackageDeal.bIsTogether = true;
                  // }

                  const mProductInPackageDeal = oProductInPackageDeal;
                  aProductsInPackageDeal.push(mProductInPackageDeal);
                }
              }
            }
            oPackageDeal.lProducts = aProductsInPackageDeal;
          }

          aStateItems.push(oPackageDeal);
        }
      }
    }
  }


  return packagedeals.lItems = aStateItems;
}

export function importFromOfAjaxCall(html)
{
  debug_actions.debugAddLogFlow('packagedeals', 'importFromOfAjaxCall');
  const htmlPackageDeals = '<div>' + html + '</div>'; // jquery heeft container nodig
  const aListsRefs = []; // een array met setjes

  let bBookingHasPreselectedPackageDeal = false;
  let bIsPreselectedPackageDealAvailable = false;
  if ( booking.iPreselectedPackageDealID !== false )
  {
    bBookingHasPreselectedPackageDeal = true;
  }

  jQuery(htmlPackageDeals).find(".subcat").each((index, elementSubcat) => {
    const aItems = [];

    jQuery(elementSubcat).find(".packagedeal").each((index, elementPackageDeal) => {

      let htmlContent = '';
      const elContent = jQuery(elementPackageDeal).find('.packagedeal__reservation-content'); // lange tekst
      if ( elContent ) htmlContent = elContent.html();

      let oImage = false;
      const elTeaserImage = jQuery(elementPackageDeal).find('.packagedeal__teaserimg img');
      if ( elTeaserImage ) oImage = elTeaserImage.attr('src');
      const bIsDebugModeEnabled = progress_select.isDebugModeEnabled();

      if ( typeof oImage === 'undefined' || oImage === false && bIsDebugModeEnabled === true )
      {
        // Fallback afbeelding
        oImage = progress.sImageURLPackageDeal;
      }

      let bIsPreselected = false;
      let sIsPreselected = jQuery(elementPackageDeal).attr('data-preselected');

      if ( sIsPreselected === true || sIsPreselected === "true" )
      {
        bIsPreselectedPackageDealAvailable = true;
        bIsPreselected = true;
      }

      aItems.push({
        iID: parseInt(jQuery(elementPackageDeal).attr('data-id')),
        sTitle: jQuery(elementPackageDeal).find('.packagedeal__title').text(),
        sPrice: jQuery(elementPackageDeal).attr('data-price'),
        iPrice: money_util.stringToCents(jQuery(elementPackageDeal).attr('data-price')),
        sPriceString: jQuery(elementPackageDeal).attr('data-price-string'),
        bIsPreselected: bIsPreselected, // is in de categorie al bovenaan gezet.. dit is nog voor weergave zoals het toevoegen van een class voor styling
        sDateUsed: DateTimeUtil.convertYYYYdashMMdashDDToDDdashMMdashYYYY(jQuery(elementPackageDeal).attr('data-date')),
        htmlSummary: jQuery(elementPackageDeal).find('.packagedeal__summary').html(),
        htmlContent: htmlContent,
        sImage: oImage
      });
    });


    let bIsPreselectedCat = false;
    let sIsPreselectedCat = jQuery(elementSubcat).attr('data-preselected');

    if ( sIsPreselectedCat === true || sIsPreselectedCat === "true" )
    {
      bIsPreselectedCat = true;
    }

    const oSubcatData = {
      iID: parseInt(jQuery(elementSubcat).attr('data-id')),
      sTitle: jQuery(elementSubcat).find('.subcat__title').text(),
      lItems: aItems,
      bIsPreselected: bIsPreselectedCat
    };

    aListsRefs.push(oSubcatData);
  });

  packagedeals.lAvailablePackageDeals = aListsRefs;

  // einde import packagedeallijst voor de gevraagde datum
  // we kunnen nu bijvoorbeeld kijken of een eventueel preset arrangement wel beschikbaar

  if ( bBookingHasPreselectedPackageDeal === true && bIsPreselectedPackageDealAvailable !== true )
  {
    // verwijder preselect en sla ergens op dat die er wel was
    booking.iPreselectedPackageDealID = false;
    progress.bThereWasAPreselectedPackageDealButItIsNotAvailable = true;
    booking_update.removePackageDealsForEveryone();
  }

}
